/* Built In Imports */
import { useRouter } from 'next/router';
import { useContext, useEffect, useRef, useState } from 'react';

/* External Imports */
import { CopyIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, Grid, Image, Text } from '@chakra-ui/react';
import copy from 'copy-to-clipboard';
import { render } from 'datocms-structured-text-to-html-string';
import filter from 'lodash/filter';
import { nanoid } from 'nanoid';


/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { getCookie } from '@components/Utility/utils';
import config from '@config';
import CountriesList from '@constants/CountriesList';
import useWindowDimensions from '@hooks/useWindowDimensions';
import { ThankYouSt } from '@ieo/Common/CompLangConfig';
import { useTranslation } from '@ieo/Components/Form/ieo/translation';
import { TextContainer } from '@ieo/Components/ThankYou/ThankYouPageElements';
import { AuthContext } from '@store/auth-context';

/* Services */
import { searchByFieldId } from '@components/Utility/Shared/SharedService';
import { mixPanel } from '@utils/Mixpanel';

let mpEventFired = false;
/**
 *
 * @param {Object} param0
 * @returns
 */
export const ThankYouSuccessScreen = ({
  pageState,
  data,
  sectionContent,
  lang,
  bodyData,
  giftingFlow,
  region,
}) => {
  // console.log('ThankYouSuccessScreen', bodyData[0]);

  const { t } = useTranslation('thank-you');
  const emailRef = useRef(null);
  const { width } = useWindowDimensions();
  const authCtx = useContext(AuthContext);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const router = useRouter();
  // console.log('=>', router);

  //console.log(bodyData[1]?.sectionContent);
  // TODO: Use the correct language
  // const ieoLoginUrl = config.NEXT_PUBLIC_IEO_LOGIN_URL.replace('LANG', 'en');

  // const eoeJoin =
  //   router.query?.flow !== 'yo' &&
  //   !giftingFlow &&
  //   giftFlowSection.sectionContent?.find(e => e.fieldId === 'eoe-join');

  const giftFlowSection = bodyData?.find(
    e => e.sectionId === 'thank-you-message'
  )?.sectionContent;

  const thankyouSection =
    bodyData?.find(e => e.sectionId === 'thank-you-message-new')
      ?.sectionContent || giftFlowSection;

  /* The above code is a JavaScript comment block that includes a console.log statement. The
  console.log statement is logging the values of the variables `giftFlowSection`, `bodyData`, and
  `thankyouSection` to the console. However, the code snippet also includes a syntax error with the
  ` */
  // console.log('giftFlowSection', bodyData, thankyouSection);

  const mobBtn = thankyouSection[6]?.linkUrl;

  const convertToPlainText = html => {
    // TODO: FInd a better solution, this is hacky
    // console.log(html.indexOf('&amp;'))
    return html
      .replaceAll('</p>', '\n')
      .replaceAll('<br>', '\n')
      .replace('<li>', '1. ')
      .replace('<li>', '2. ')
      .replace('<li>', '3. ')
      .replaceAll('amp;', '')
      .replace(/(<([^>]+)>)/g, '');
  };

  const copyToClipboard = () => {
    if (width > 768) {
      copy(emailRef.current.innerHTML, {
        format: 'text/html',
      });
    } else {
      copy(convertToPlainText(emailRef.current.innerHTML), {
        format: 'text',
      });
    }
  };

  useEffect(() => {
    setIsLoggedIn(authCtx.isLoggedIn);
    // console.log('authCtx', authCtx);
  }, [authCtx.isLoggedIn]);

  if (giftingFlow) {
    if (!mpEventFired) {
      const Mixpanel = mixPanel(router.asPath);
      // console.log('router.query', router.query);
      if (
        router.asPath?.indexOf('/in/') > -1 &&
        router.query?.status === 'COMPLETED'
      ) {
        const mixPanelObj = {
          program_language:
            config.lngList[router.query?.programLanguage?.toLowerCase()],
          program_amount: data.tCost,
          currency: router.query?.currency,
          // discounted_amount: data.tCost,
          has_whatsapp: router.query?.has_whatsapp,
          // payment_gateway: '',
          // payment_method: '',
          order_id: router.query?.transactionId,
        };

        const cookieName = `mp-event-s${data?.data?.txnId}`;
        const mixPanelCookieObjData =
          getCookie(cookieName) && JSON.parse(getCookie(cookieName));
        if (!mixPanelCookieObjData) {
          const cookieExpiryDate = new Date(
            new Date().setDate(new Date().getDate() + 1)
          );
          const cookieObjData = { txnId: data?.data?.txnId };
          document.cookie = `${decodeURIComponent(
            cookieName
          )}=${decodeURIComponent(
            JSON.stringify(cookieObjData)
          )};expires=${cookieExpiryDate.toGMTString()};domain=${
            config.COOKIE_DOMAIN
          };path=/;secure=true;samesite=true;`;
          if (Object.keys(Mixpanel)?.length > 0) {
            Mixpanel.track('ie_registration_successful', mixPanelObj);
            mpEventFired = true;
            if (data?.ssoId) {
              Mixpanel?.alias(data?.ssoId);
              Mixpanel.identify(data?.ssoId);
              Mixpanel.people.set({
                $name: `${data?.fname} ${data?.lname}`,
                $email: data?.email,
              });
            }
          }
        }
      }
    }
    const countryObj = filter(CountriesList, function (country) {
      return country?.value?.toUpperCase() === data.data?.pgmCtry;
    })[0];
    // console.log('countryObj', countryObj);

    return (
      <Flex
        maxW={'700px'}
        px={{ base: '20px', md: '20px', lg: '80px' }}
        flexDirection={'column'}
        alignItems={'center'}
        justifyContent={'center'}
        textAlign={'center'}
        height={'full'}
        py={12}
      >
        <img
          src="https://static.sadhguru.org/d/46272/1699437335-icon_checkmark.svg"
          alt=""
          width={54}
          height={54}
        />

        {giftFlowSection && (
          <Text
            fontSize={'22px'}
            color={'#00A171'}
            mb={4}
            mt={2}
            as="h2"
            {...ThankYouSt[lang]?.h2}
          >
            {giftFlowSection[0]?.titleText}
          </Text>
        )}
        <TextContainer
          mb={8}
          fontFamily={'FedraSansStd-book'}
          fontSize={'18px'}
          fontWeight="normal"
        >
          <StructuredTextParser
            str={render(giftFlowSection[1]?.body)}
            className="errorScreen"
            textAlign="center"
            {...ThankYouSt[lang]?.successSt}
          />

          <style global jsx>
            {`
              .errorScreen p {
                margin-bottom: 7px;
              }
              .errorScreen p a {
                color: #e86f34;
                text-decoration: underline;
              }
              .thankyou p {
                min-height: 16px;
                font-size: 12px;
                line-height: 16px;
              }
              .thankyou ol {
                padding-left: 20px;
              }
              .thankyou li {
                font-size: 12px;
                line-height: 16px;
              }
              .thankyou a {
                color: #e86f34;
              }
            `}
          </style>
          <Box
            ref={emailRef}
            textAlign={'left'}
            fontSize={'12px'}
            border={'1px solid #B49168'}
            borderRadius={'11px'}
            p={'24px'}
            className={'thankyou'}
          >
            <StructuredTextParser
              mt={'0px'}
              str={render(giftFlowSection[2]?.body)
                .replace(/{NAME}/g, data.data?.name || '')
                .replace(
                  /{EXT}/g,
                  `vouchercode=${data.data?.code || ''}&lang=${
                    data.data?.lang || ''
                  }`
                )
                .replace(/{CCODE}/g, data.data?.code || '')
                .replace(
                  /{LANG}/g,
                  config.lngListTrans[data.data?.lang?.toLowerCase()] || ''
                )
                .replace(/{VALIDTILL}/g, data.data?.validTill || '')
                .replace(/{COUNTRY}/g, countryObj?.name || '')}
              {...ThankYouSt[lang]?.successSt}
            />
          </Box>
          <Button
            size="sm"
            border="2px dotted #3652B8"
            borderRadius={'50px'}
            backgroundColor={'#fff'}
            color={'#3652B8'}
            fontFamily={'Fedra Sans Std'}
            fontWeight={400}
            fontSize={'12px'}
            padding={'2px 20px'}
            float={'right'}
            mt={'-56px'}
            mr={'24px'}
            onClick={copyToClipboard}
          >
            <CopyIcon mr={2} /> Copy Text
          </Button>
        </TextContainer>
        <StructuredTextParser
          mt="32px"
          mb={{ base: '28px', md: '40px' }}
          str={render(bodyData[3]?.body?.value)}
          fontFamily={'FedraSansStd-book'}
          fontSize={'18px'}
          fontWeight="normal"
          textDecoration="underline"
          color="#E86F34"
          textAlign="center"
          className="errorScreen"
          {...ThankYouSt[lang]?.successSt}
        />
        <StructuredTextParser
          str={render(giftFlowSection[3]?.body)}
          className="errorScreen"
          textAlign="center"
          {...ThankYouSt[lang]?.successSt}
        />
        {data && (
          <>
            <Box borderTop={'solid 1px #E9E8E8'} w={'100%'} mb={6} />

            <StructuredTextParser
              str={render(bodyData[4]?.body?.value)}
              mb={6}
              textAlign="center"
              {...ThankYouSt[lang]?.regSt}
              className="errorScreen"
            />

            <Grid
              templateColumns={{ base: 'auto', sm: 'auto auto' }}
              gridColumnGap={6}
              gridRowGap={1}
              w={{ base: 'full', lg: '90%' }}
              justifyContent={'space-between'}
              textAlign={'left'}
              fontFamily={'FedraSansStd-book'}
            >
              {[
                {
                  label: giftFlowSection[5]?.data?.name || t('success.name'),
                  value: `${data?.data?.name}`,
                },
                {
                  label: giftFlowSection[5]?.data?.email || t('success.email'),
                  value: data?.data?.email,
                },
                {
                  label:
                    giftFlowSection[5]?.data?.transactionid ||
                    t('success.transactionId'),
                  value: data?.data?.txnId,
                },
              ]
                .filter(item => item.value)
                .map(({ label, value }) => (
                  <>
                    {value && value.indexOf('undefined') < 0 && (
                      <>
                        <Box color="#747474">{label}:</Box>
                        <Box
                          fontFamily="FedraSansStd-book"
                          fontWeight="600"
                          mb="10px"
                          color="#433F3C"
                        >
                          {value}
                        </Box>
                      </>
                    )}
                  </>
                ))}
            </Grid>
          </>
        )}
      </Flex>
    );
  }

  const MobileUiThank = () => {
    return (
      <Box display="flex" flexDir="column" textAlign="left">
        {thankyouSection[4]?.cards?.map((item, i) => (
          <Box
            display="flex"
            gap="20px"
            position="relative"
            _before={{
              content: '""',
              borderLeft: '2px solid #C6B399',
              position: 'absolute',
              h: i == 3 ? '0px' : '115%',
              left: '15px',
            }}
            key={nanoid(5)}
          >
            <Box position="relative" zIndex="3">
              <Image src={item?.thumbnail?.url} pt={1} />
            </Box>
            <Box>
              <Box>
                <StructuredTextParser
                  str={render(item?.description).replace(
                    /{EMAIL}/g,
                    data?.email || ''
                  )}
                  fontFamily="FedraSansStd-medium"
                  fontSize="14px"
                  color="#7A6E4B"
                  className="email-orange-text"
                  mt="0px"
                  mb="0px"
                />
                <Box
                  fontFamily="FedraSansStd-book"
                  // textAlign="center"
                  fontSize="14px"
                  color="#7A6E4B"
                  mt="0px"
                  mb="10px"
                >
                  {item?.title.replace(/{EMAIL}/g, data?.email || '')}
                </Box>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    );
  };

  const DesktopUiThank = () => {
    return (
      <Box display="flex" flexDir="column" textAlign="left">
        {thankyouSection[3]?.cards?.map((item, i) => (
          <Box
            display="flex"
            gap="20px"
            position="relative"
            _before={{
              content: '""',
              borderLeft: '2px solid #C6B399',
              position: 'absolute',
              h: i == 1 ? '0px' : '115%',
              left: '15px',
            }}
            key={nanoid(5)}
          >
            <Box position="relative" zIndex="3" top="4px">
              <Image src={item?.thumbnail?.url} />
            </Box>
            <Box>
              <StructuredTextParser
                str={render(item?.description).replace(
                  /{EMAIL}/g,
                  data?.email || ''
                )}
                fontFamily="FedraSansStd-medium"
                fontSize="14px"
                color="#7A6E4B"
                className="email-orange-text"
                mt="0px"
                mb="0px"
              />
              <Box
                fontFamily="FedraSansStd-book"
                // textAlign="center"
                fontSize="14px"
                color="#7A6E4B"
                mt="0px"
                mb="10px"
              >
                {item?.title.replace(/{EMAIL}/g, data?.email || '')}
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    );
  };

  /** Mixpanel event */

  if (!mpEventFired) {
    if (
      router.asPath?.indexOf('/in/') > -1 &&
      router.query?.status === 'COMPLETED'
    ) {
      const Mixpanel = mixPanel(router.asPath);
      // console.log('router.query', router.query);
      const mixPanelObj = {
        program_language:
          config.lngList[router.query?.programLanguage?.toLowerCase()],
        program_amount: data.tCost,
        currency: router.query?.currency,
        // discounted_amount: data.tCost,
        has_whatsapp: router.query?.has_whatsapp,
        // payment_gateway: '',
        // payment_method: '',
        order_id: router.query?.transactionId,
      };
      const cookieName = `mp-event-s${router.query?.transactionId}`;
      const mixPanelCookieObjData =
        getCookie(cookieName) && JSON.parse(getCookie(cookieName));
      if (!mixPanelCookieObjData) {
        const cookieExpiryDate = new Date(
          new Date().setDate(new Date().getDate() + 1)
        );
        const cookieObjData = { txnId: router.query?.transactionId };
        document.cookie = `${decodeURIComponent(
          cookieName
        )}=${decodeURIComponent(
          JSON.stringify(cookieObjData)
        )};expires=${cookieExpiryDate.toGMTString()};domain=${
          config.COOKIE_DOMAIN
        };path=/;secure=true;samesite=true;`;
        if (Object.keys(Mixpanel)?.length > 0) {
          Mixpanel.track('ie_registration_successful', mixPanelObj);
          mpEventFired = true;
          if (data?.ssoId) {
            Mixpanel?.alias(data?.ssoId);
            Mixpanel.identify(data?.ssoId);
            Mixpanel.people.set({
              $name: `${data?.fname} ${data?.lname}`,
              $email: data?.email,
            });
          }
        }
      }
    }
  }

  /** Mixpanel event */

  return (
    <>
      <Flex
        maxW={'550px'}
        px={{ base: '15px', md: '30px' }}
        flexDirection={'column'}
        alignItems={'center'}
        justifyContent={'center'}
        textAlign={'center'}
        height={'full'}
        py={{ base: 5, md: 12 }}
        mx="auto"
        w="full"
      >
        {/* Start new section*/}
        <StructuredTextParser
          str={render(
            searchByFieldId(thankyouSection, 'thank-head')?.body
          )?.replace(/{NAME}/g, `${data?.fname} ${data?.lname}` || '')}
          lang={lang}
          fontFamily="FedraSansStd-book"
          pb="20px"
          mt="0"
          maxW="full"
          fontSize="16px"
          className="lastP"
        />

        <Box display="flex" w="full" alignItems="flex-start">
          {' '}
          <Image
            src="https://static.sadhguru.org/d/46272/1716609665-mobile-i.png"
            alt=""
            width={{ base: '135px', md: '176px' }}
            objectFit="contain"
            display={{ base: 'block', md: 'none' }}
          />
          <Image
            src="https://static.sadhguru.org/d/46272/1716392285-group-1171277166.png"
            alt=""
            width={{ base: '135px', md: '176px' }}
            objectFit="contain"
            display={{ base: 'none', md: 'block' }}
          />
          <Box fontFamily="FedraSansStd-medium" textAlign="left">
            {searchByFieldId(thankyouSection, 'thank-msg-head-right') && (
              <StructuredTextParser
                str={render(
                  searchByFieldId(thankyouSection, 'thank-msg-head-right').body
                )}
                lang={lang}
                fontFamily="FedraSansStd-book"
                pb="20px"
                px="15px"
                mt="0"
                color="#433F3C"
                fontSize={{ base: '13px', md: '16px' }}
              />
            )}
          </Box>
        </Box>
        <Box borderBottom="1px solid #E9E8E8" h="1px" w="full" my="10px" />
        <Box
          bgColor="#F3EDDE"
          maxW={{ base: 'auto', md: '330px' }}
          p={{
            base: mobBtn ? '0px 10px 0px 10px' : '0px 10px 20px 10px',
            md: '10px 20px 0px 20px',
          }}
          w="full"
          mx="auto"
          mt="10px"
        >
          {searchByFieldId(thankyouSection, 'thank-msg-head') && (
            <StructuredTextParser
              str={render(
                searchByFieldId(thankyouSection, 'thank-msg-head')?.body
              )}
              fontFamily="FedraSansStd-medium"
              textAlign="center"
              fontSize="14px"
              color="#7A6E4B"
              mb="15px"
            />
          )}

          {searchByFieldId(thankyouSection, 'id-ar-mob-specific') && (
            <Box display={{ base: 'block', md: 'none' }}>
              <StructuredTextParser
                str={render(
                  searchByFieldId(thankyouSection, 'id-ar-mob-specific')?.body
                )}
                lang={lang}
                fontSize="14px"
                color="#7A6E4B"
                pb="20px"
                mt="0"
                maxW="full"
                fontFamily="FedraSansStd-book"
                mb="10px"
              />
            </Box>
          )}

          <Box
            position="relative"
            _before={{
              content: '""',
              borderLeft: '2px solid #C6B399',
              position: 'absolute',
              h: '10%',
              left: '15px',
              top: '-10px',
            }}
            _after={{
              content: '""',
              borderLeft: '2px solid #C6B399',
              position: 'absolute',
              h: '10%',
              left: '15px',
              bottom: '5px',
            }}
            display={{ base: 'none', md: 'block' }}
          >
            {bodyData[1] &&
              thankyouSection[3]?._modelApiKey == 'card_info2_column_group' && (
                <DesktopUiThank />
              )}
          </Box>

          <Box
            position="relative"
            _before={{
              content: '""',
              borderLeft: '2px solid #C6B399',
              position: 'absolute',
              h: '10%',
              left: '15px',
              top: '-10px',
            }}
            _after={{
              content: '""',
              borderLeft: '2px solid #C6B399',
              position: 'absolute',
              h: '10%',
              left: '15px',
              bottom: '5px',
            }}
            display={{ base: 'block', md: 'none' }}
          >
            {bodyData[1] &&
              thankyouSection[4]?._modelApiKey == 'card_info4_column_group' && (
                <MobileUiThank />
              )}
          </Box>
          {thankyouSection[5]?.linkUrl && (
            <Button
              bgColor="#3652B8"
              color="#fff"
              borderRadius="50px"
              p="25px"
              w="full"
              fontFamily="FedraSansStd-book"
              position="relative"
              top="20px"
              as={'a'}
              display={{ base: 'none', md: 'inherit' }}
              href={
                isLoggedIn
                  ? thankyouSection[5]?.linkUrl
                  : config.EMAIL_LOGIN_URL.replace('[EMAIL]', data?.email)
              }
              lineHeight={0.2}
            >
              {thankyouSection[5]?.buttonText}
            </Button>
          )}

          {mobBtn && (
            <Button
              bgColor="#3652B8"
              color="#fff"
              borderRadius="50px"
              p="25px"
              w="full"
              fontFamily="FedraSansStd-book"
              position="relative"
              top="20px"
              as={'a'}
              display={{ base: 'block', md: 'none' }}
              href={mobBtn}
              lineHeight={0.2}
            >
              {thankyouSection[6]?.buttonText}
            </Button>
          )}
        </Box>
        {searchByFieldId(thankyouSection, 'web-access-mob') &&
          lang !== 'id' &&
          lang !== 'ar' && (
            <>
              <Box w="full" display={{ base: 'block', md: 'none' }} pt={6}>
                <StructuredTextParser
                  str={render(
                    searchByFieldId(thankyouSection, 'web-access-mob').body
                  )}
                  {...ThankYouSt[lang]?.successSt}
                  fontSize="14px"
                  fontFamily="FedraSansStd-book"
                  color="#747474"
                  className="pAlink"
                />
              </Box>
              <Box
                borderBottom="1px solid #E9E8E8"
                h="1px"
                w="full"
                my="10px"
                display={{ base: 'block', md: 'none' }}
              />
            </>
          )}
        {searchByFieldId(thankyouSection, 'transaction-id') && (
          <Box w="full" pt={{ base: 0, md: 10 }}>
            {data?.txnId && (
              <StructuredTextParser
                str={render(
                  searchByFieldId(thankyouSection, 'transaction-id').body
                ).replace(/{TXNID}/g, data?.txnId || '')}
                {...ThankYouSt[lang]?.successSt}
                fontSize="14px"
                fontFamily="FedraSansStd-book"
                color="#747474"
                className="secondPtext"
              />
            )}
          </Box>
        )}
        {searchByFieldId(thankyouSection, 'bottom-msg') && (
          <Box w="full">
            <StructuredTextParser
              str={render(
                searchByFieldId(thankyouSection, 'bottom-msg').body
              ).replace(/{TXNID}/g, data?.txnId || '')}
              className="email-text"
              {...ThankYouSt[lang]?.successSt}
              fontSize="14px"
              fontFamily="FedraSansStd-book"
              color="#4A4037"
              mb="30px"
            />
          </Box>
        )}
        <style>
          {`
          .email-text a {
            color:#3652B8;
            text-decoration:underline;
          }
          .pAlink p a{color: #CE6113; text-decoration:underline}
          .secondPtext p:last-child {
            color: #433F3C;
            font-family:'FedraSansStd-medium'
          }
          .lastP p:last-child  {
            padding-top:15px;
          }
          .email-orange-text a {
            color:#CE6113;
            border-bottom:1px dashed #CE6113;
          }
          `}
        </style>
      </Flex>
      <Box display={{ base: 'block', md: 'none' }}>
        {searchByFieldId(thankyouSection, 'mob-banner') && (
          <Image
            alt=""
            w="full"
            src={
              searchByFieldId(thankyouSection, 'mob-banner')?.mobileImage?.url
            }
          />
        )}
      </Box>

      {router.query?.flow === 'affiliate-test' && (
        <Image
          src={`https://netcore.g2afse.com/success.jpg?afid=${router.query?.transactionId}&afstatus=1&afprice=${data.tCost}&custom_field1=${data.tCost}`}
          height="1"
          width="1"
          alt=""
        />
      )}

      {/* End new section*/}

      {/*=====================================================
        Old code of thankyou below 
        =======================================================*/}

      {/*   <Flex
      maxW={'700px'}
      px={{ base: '20px', md: '20px', lg: '80px' }}
      flexDirection={'column'}
      alignItems={'center'}
      justifyContent={'center'}
      textAlign={'center'}
      height={'full'}
      py={12}
    >
      <img src={checkIcon.src} width={54} height={54} /> 
      {bodyData[1].sectionContent && (
        <Text
          fontSize={'22px'}
          color={'#00A171'}
          mb={4}
          mt={2}
          as="h2"
          {...ThankYouSt[lang]?.h2}
        >
          {bodyData[1].sectionContent[0]?.titleText}
        </Text>
      )}
      <TextContainer
        mb={4}
        fontFamily={'FedraSansStd-book'}
        fontSize={'18px'}
        // fontWeight="normal"
      >
        {searchByFieldId(bodyData[1].sectionContent, 'thank-head') && (
          <StructuredTextParser
            str={render(
              searchByFieldId(bodyData[1].sectionContent, 'thank-head').body
            )}
            className="errorScreen"
            textAlign="center"
            color="#433F3C"
            {...ThankYouSt[lang]?.successSt}
          />
        )} 

        <Box bgColor="#f3edde" p="20px 31px" borderRadius="4px" mt="35px">
          {searchByFieldId(
            bodyData[1].sectionContent,
            'thank-msg-head-center'
          ) && (
            <StructuredTextParser
              str={render(
                searchByFieldId(
                  bodyData[1].sectionContent,
                  'thank-msg-head-center'
                ).body
              )}
              mx="auto"
              className=""
              textAlign="center"
              color="#433F3C"
              {...ThankYouSt[lang]?.successSt}
            />
          )}
          <Box ml={{ base: '12px', md: '37px' }}>
            {searchByFieldId(
              bodyData[1].sectionContent,
              'thank-msg-head-left'
            ) && (
              <StructuredTextParser
                str={render(
                  searchByFieldId(
                    bodyData[1].sectionContent,
                    'thank-msg-head-left'
                  ).body
                )}
                mx="auto"
                className=""
                // mx="auto"
                color="#000"
                maxW="320px !important"
                {...ThankYouSt[lang]?.successSt}
                fontSize={{ base: '16px' }}
              />
            )}

            {searchByFieldId(bodyData[1].sectionContent, 'thank-msg') && (
              <StructuredTextParser
                str={render(
                  searchByFieldId(bodyData[1].sectionContent, 'thank-msg').body
                ).replace(/{EMAIL}/g, data?.email || '')}
                className=""
                maxW="300px !important"
                // pl={{ base: '5px', md: '10px' }}
                color="#433F3C"
                {...ThankYouSt[lang]?.successSt}
                fontSize="16px"
              />
            )}
          </Box>

          <Show breakpoint="(min-width: 769px)">
            <SimpleButton
              as={'a'}
              href={ieoLoginUrl}
              mb="8px"
              borderRadius="full"
              border="none"
              whiteSpace="normal"
              overflowWrap="break-word"
              style={{
                buttonStyle: 'Orange',
                buttonText: bodyData[1].sectionContent[5]?.buttonText,
                linkUrl: ieoLoginUrl,
              }}
              mt="25px"
              bg="#3652B8 !important"
              w={{ base: '260px', md: '368px' }}
            />
          </Show>
        </Box> 

        <style global jsx>
          {`
            .errorScreen p {
              margin-bottom: 7px;
            }
            .errorScreen p a {
              color: #e86f34;
              text-decoration: underline;
            }
            .lightYellow {
              background: #f3edde;
            }
          `}
        </style>
        */}
      {/* <StructuredTextParser str={render(data[1]?.body?.value?.document?.children[1])} fontFamily={'FedraSansStd-book'} fontSize={'18px'} fontWeight="normal" textAlign="center" />


        <StructuredTextParser str={render(data[1]?.body?.value?.document?.children[2])} fontFamily={'FedraSansStd-book'} fontSize={'18px'} fontWeight="normal" textAlign="center" /> */}
      {/* </TextContainer>
      <Show breakpoint="(max-width: 768px)">
        <SimpleButton
          as={'a'}
          href={ieoLoginUrl}
          mb="8px"
          borderRadius="full"
          border="none"
          whiteSpace="normal"
          overflowWrap="break-word"
          style={{
            buttonStyle: 'Orange',
            buttonText: bodyData[1].sectionContent[5]?.buttonText,
            linkUrl: ieoLoginUrl,
          }}
          bg="#3652B8 !important"
          w={{ base: '260px', md: '368px' }}
        />
      </Show> 
      {data?.resetUrl && (
        <Link
          color={'#E86F34'}
          textDecoration={'underline'}
          mb={4}
          mt={0}
          href={data.resetUrl}
        >
          {t('success.setPassword')}
        </Link>
      )} 
      {searchByFieldId(bodyData[1].sectionContent, 'bottom-msg') && (
        <Box maxW="392px">
          <StructuredTextParser
            str={render(
              searchByFieldId(bodyData[1].sectionContent, 'bottom-msg').body
            ).replace(/{TXNID}/g, data?.txnId || '')}
            className="email-text"
            textAlign="center"
            {...ThankYouSt[lang]?.successSt}
            fontSize="16px"
            fontFamily="FedraSansStd-book"
            color="#000000"
          />
        </Box>
      )}
      {eoeJoin &&
        (router.query.region === 'in' ||
          router.query.region === 'us' ||
          router.query.region === 'ca') && (
          <Box
            maxW="430px"
            mt={{ base: 3, md: 6 }}
            px={{ base: 3, md: 7 }}
            bgColor="#2A1941"
            borderRadius={3}
            w="full"
          >
            <StructuredTextParser
              str={render(eoeJoin?.body)}
              color="#fff"
              fontFamily="FedraSansStd-book"
              textAlign="center"
              mb={4}
              className="pAlink"
            />
          </Box>
        )}
      <style>
        {`
          .email-text a{
            color:#000;
            text-decoration:underline;
          }
          .pAlink p a{color: #FFC05A; text-decoration:underline}
          `}
      </style>

      {/*
      {data?.resetUrl && (
        <Link
          color={'#E86F34'}
          textDecoration={'underline'}
          mb={8}
          href={data.resetUrl}
        >
          {t('success.setPassword')}
        </Link>
      )} */}
      {/* <StructuredTextParser
        mt="32px"
        mb={{ base: '28px', md: '40px' }}
        str={render(bodyData[3]?.body?.value)}
        fontFamily={'FedraSansStd-book'}
        fontSize={'18px'}
        fontWeight="normal"
        textDecoration="underline"
        color="#E86F34"
        textAlign="center"
        className="errorScreen"
        {...ThankYouSt[lang]?.successSt}
      />
      {data && (
        <>
          <Box borderTop={'solid 1px #E9E8E8'} w={'100%'} mb={6} />

          <StructuredTextParser
            str={render(bodyData[4]?.body?.value)}
            mb={6}
            textAlign="center"
            {...ThankYouSt[lang]?.regSt}
            className="errorScreen"
          />

          <Grid
            templateColumns={{ base: 'auto', sm: 'auto auto' }}
            gridColumnGap={6}
            gridRowGap={1}
            w={{ base: 'full', lg: '90%' }}
            justifyContent={'space-between'}
            textAlign={'left'}
            fontFamily={'FedraSansStd-book'}
          >
            {[
              {
                label:
                  bodyData[1]?.sectionContent[5]?.data?.name ||
                  t('success.name'),
                value: `${data?.fname} ${data?.lname}`,
              },
              {
                label:
                  bodyData[1]?.sectionContent[5]?.data?.email ||
                  t('success.email'),
                value: data?.email,
              },
              {
                label:
                  bodyData[1]?.sectionContent[5]?.data?.transactionid ||
                  t('success.transactionId'),
                value: data?.txnId,
              },
            ]
              .filter(item => item.value)
              .map(({ label, value }) => (
                <>
                  {value && value.indexOf('undefined') < 0 && (
                    <>
                      <Box color="#747474">{label}:</Box>
                      <Box
                        fontFamily="FedraSansStd-book"
                        fontWeight="600"
                        mb="10px"
                        color="#433F3C"
                      >
                        {value}
                      </Box>
                    </>
                  )}
                </>
              ))}
          </Grid>
        </>
      )} 
    </Flex>
    */}
    </>
  );
};
